/* NEXRA 11/10 - o so luong trang san pham [ - 1 + ], ben TRAI nut mua. Markup + kieu: snippets/buy-buttons.liquid.

   O la input name="quantity" nam TRONG form mua => product-form.js cua Dawn gui kem khi them gio (khong sua file do).
   File nay chi lo: nut - / +, loc so (mac dinh 1, toi thieu 1, khong nhan 0 / so am / chu), tran theo ton, giu so khi doi mau.

   GIU SO KHI DOI MAU / SIZE
     - doi size, doi mau bang AJAX: Dawn khong render lai khoi nut mua nen o van la o cu, so giu nguyen.
       Chi cap nhat tran (data-max) theo ban server moi (su kien variantChange).
     - doi mau bang LINK sang trang mau khac (hang Color cua dong Impact): ghi so vao sessionStorage luc bam link,
       trang moi doc lai (chi trong 30 giay, doc xong xoa).

   VUOT TON
     Tran = data-max (ton cua bien the se mua, toi da 50 = muc Shopify dang nhan moi bien the trong mot gio). Bam + hoac go qua tran thi so ve tran va
     hien cau cua Dawn "You can only add N of this item to your cart." trong khoi bao loi cua nut mua (cung cho voi loi
     server). Loi server (vd gio da co san mot phan) van do product-form.js hien nhu truoc.
     Shopify co the THEM MOT PHAN roi moi tra loi loi ("Only N items were added to your cart due to availability."):
     khi nut mua bao loi, file nay ve lai icon gio + ngan keo theo gio that de so tren icon khong sai.

   Moi cho ghi DOM deu SO TRUOC KHI GHI: khoi info co nhieu MutationObserver (nx-pdp.js, nx-cs.js, nx-bis.js, thanh mua dinh). */
(function () {
  if (window.NXQty) return;

  // 50 = so Shopify dang cho them toi da moi bien the trong mot gio (do 11/10: ton 99, xin 51 thi chi nhan 50).
  var CAP = 50;
  var KEY = 'nx_qty_mang';
  var HAN = 30000;
  var IN = '[data-nx-qty-in]';

  function o(root) { return (root || document).querySelector(IN); }

  function toiDa(i) {
    var m = parseInt(i.getAttribute('data-max'), 10);
    return m > 0 && m < CAP ? m : CAP;
  }

  // So dang co trong o. 0 = rong / khong hop le.
  function so(i) {
    var n = parseInt(String(i.value || '').replace(/[^0-9]/g, ''), 10);
    return n > 0 ? n : 0;
  }

  function bao(i, mx) {
    var f = i.closest ? i.closest('product-form') : null;
    if (!f || typeof f.handleErrorMessage !== 'function') return;
    if (mx) {
      var t = (window.cartStrings && window.cartStrings.quantityError) || 'You can only add [quantity] of this item to your cart.';
      f.handleErrorMessage(String(t).replace('[quantity]', mx));
    } else {
      // Khach vua doi so luong ve muc hop le: xoa chu dang hien (ca loi server cua lan them truoc).
      var w = f.querySelector('.product-form__error-message-wrapper');
      if (w && !w.hidden) f.handleErrorMessage();
    }
  }

  // Dat so hop le vao o, cap nhat nut tru va nhan nut mua. noi = co hien / xoa thong bao vuot ton khong.
  function dat(i, n, noi) {
    var mx = toiDa(i);
    var vuot = n > mx;
    if (vuot) n = mx;
    if (!(n >= 1)) n = 1;
    var s = String(n);
    if (i.value !== s) i.value = s;
    var hop = i.closest ? i.closest('[data-nx-qty]') : null;
    var tru = hop ? hop.querySelector('[data-nx-qty-b="-1"]') : null;
    if (tru && tru.disabled !== (n <= 1)) tru.disabled = n <= 1;
    if (noi) bao(i, vuot ? mx : 0);
    // Nhan nut mua doi theo so luong (assets/nx-cs.js): tu 2 cai chi con "Add to cart", bo phan gia.
    if (window.NXCs && typeof window.NXCs.sync === 'function') window.NXCs.sync();
    return n;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-nx-qty-b]');
    if (b) {
      e.preventDefault();
      var hop = b.closest('[data-nx-qty]');
      var i = hop ? hop.querySelector(IN) : null;
      if (!i) return;
      var d = parseInt(b.getAttribute('data-nx-qty-b'), 10) || 0;
      dat(i, (so(i) || 1) + d, true);
      return;
    }
    // Doi mau bang link (trang mau khac / trang goc ?variant=): mang so luong sang trang moi.
    var a = t.closest('a.nx-sib__item');
    if (a) {
      var j = o();
      if (!j) return;
      var n = so(j) || 1;
      try {
        if (n > 1) window.sessionStorage.setItem(KEY, JSON.stringify({ q: n, t: Date.now() }));
        else window.sessionStorage.removeItem(KEY);
      } catch (err) {}
    }
  }, true);

  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.matches(IN)) return;
    // Chi giu chu so, bo so 0 dung dau (khong nhan 0, so am, chu). O rong trong luc dang go thi de yen, roi o moi ve 1.
    var v = String(i.value || '').replace(/[^0-9]/g, '').replace(/^0+/, '').slice(0, 4);
    if (v === '') {
      if (i.value !== '') i.value = '';
      return;
    }
    dat(i, parseInt(v, 10), true);
  });

  function chot(i) { if (i) dat(i, so(i) || 1, false); }

  document.addEventListener('change', function (e) {
    var i = e.target;
    if (i && i.matches && i.matches(IN)) chot(i);
  });
  document.addEventListener('focusout', function (e) {
    var i = e.target;
    if (i && i.matches && i.matches(IN)) chot(i);
  });

  document.addEventListener('keydown', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.matches(IN)) return;
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      dat(i, (so(i) || 1) + (e.key === 'ArrowUp' ? 1 : -1), true);
    } else if (e.key === 'Enter') {
      // Enter = gui form (nut mua tu xu ly khoa / chua chon size). Chot so truoc khi gui.
      chot(i);
    }
  });

  // Truoc khi form mua duoc gui: so trong o phai hop le (pha capture, chay truoc product-form.js).
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.querySelector) chot(f.querySelector(IN));
  }, true);

  // Dawn doi bien the bang AJAX: khoi nut mua khong render lai, chi lay tran moi tu HTML server vua tra ve.
  function ganPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      try {
        var d = ev && ev.data;
        if (!d || !d.html || !d.sectionId || !d.html.getElementById) return;
        var cu = document.getElementById('NxQty-' + d.sectionId);
        var moi = d.html.getElementById('NxQty-' + d.sectionId);
        if (!cu || !moi) return;
        var mx = moi.getAttribute('data-max') || '';
        if (cu.getAttribute('data-max') !== mx) cu.setAttribute('data-max', mx);
        var n = so(cu) || 1;
        if (n > toiDa(cu)) dat(cu, n, true);
      } catch (e) {}
    });
  }

  // Nut mua bao loi (product-form.js ban cartError): Shopify co the da them mot phan vao gio => ve lai icon gio + ngan keo.
  function ganLoiGio() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartError) return;
    subscribe(PUB_SUB_EVENTS.cartError, function (ev) {
      if (!ev || ev.source !== 'product-form') return;
      if (!window.NXCs || typeof window.NXCs.veGio !== 'function') return;
      var goc = (window.routes && window.routes.cart_url) || '/cart';
      fetch(goc + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sec) { if (sec && sec['cart-icon-bubble']) window.NXCs.veGio(sec, false); })
        .catch(function () {});
    });
  }

  function nhan() {
    var d = null;
    try {
      d = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      window.sessionStorage.removeItem(KEY);
    } catch (e) {}
    var i = o();
    if (!i) return;
    if (d && d.q > 1 && d.t && Date.now() - d.t < HAN && Date.now() >= d.t) dat(i, parseInt(d.q, 10) || 1, true);
    else chot(i);
  }

  function boot() {
    nhan();
    ganPubSub();
    ganLoiGio();
  }

  window.NXQty = {
    get: function () { var i = o(); return i ? (so(i) || 1) : 1; },
    set: function (n) { var i = o(); return i ? dat(i, parseInt(n, 10) || 1, true) : 1; }
  };
  // Quay lai bang nut Back (trang lay tu bo nho dem): dong bo nut tru + nhan nut mua voi so dang co.
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) chot(o()); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
